module.exports = __webpack_public_path__ + "img/5.93240b87.jpeg";